import type { BravadoCardItem } from '~/components/partials/landings/ui/BravadoItemCard.vue';

export const benefits: Array<BravadoCardItem> = [
  {
    logo: require('./images/icons/plan-icon.svg'),
    animation: 'fade-right',
    title: '401(k) plan',
    subtitle: 'With 4% employer matching',
    color: 'purple-1',
  },
  {
    logo: require('./images/icons/calendar-icon.svg'),
    animation: 'fade-up',
    title: 'Unlimited PTO',
    subtitle: 'And yes, we actually want you to use it',
    color: 'purple-3',
  },
  {
    logo: require('./images/icons/health-icon.svg'),
    animation: 'fade-up',
    title: 'Health Care',
    subtitle: 'Comprehensive health, vision & dental',
    color: 'cyan-1',
  },
  {
    logo: require('./images/icons/maternity-icon.svg'),
    animation: 'fade-left',
    title: 'Paid Leave',
    subtitle: '4 months paternity and maternity leave',
    color: 'cyan-2',
  },
];

export const extraBenefits = [
  {
    image: require('~/components/partials/landings/careers/images/benefits/1.webp'),
    title: 'On-demand video (e.g. Netflix, Hulu, HBO)',
  },
  {
    image: require('~/components/partials/landings/careers/images/benefits/2.webp'),
    title: 'Streaming music (e.g. Spotify, Apple Music)',
  },
  {
    image: require('~/components/partials/landings/careers/images/benefits/3.webp'),
    title: 'Mindfulness (Calm App membership)',
  },
  {
    image: require('~/components/partials/landings/careers/images/benefits/4.webp'),
    title: 'Shopping/grocery service (e.g. Postmates, Amazon Prime)',
  },
  {
    image: require('~/components/partials/landings/careers/images/benefits/5.webp'),
    title: 'Monthly credits for meals',
  },
  {
    image: require('~/components/partials/landings/careers/images/benefits/6.webp'),
    title: 'Quarterly book stipend',
  },
  {
    image: require('~/components/partials/landings/careers/images/benefits/7.webp'),
    title: 'Annual professional development stipend',
  },
  {
    image: require('~/components/partials/landings/careers/images/benefits/8.webp'),
    title: 'Work from home stipend',
  },
  {
    image: require('~/components/partials/landings/careers/images/benefits/9.webp'),
    title: 'A flexible vacation policy',
  },
  {
    image: require('~/components/partials/landings/careers/images/benefits/10.webp'),
    title: 'Once a month company-wide Carpe Diem day off',
  },
];

export const values: Array<BravadoCardItem> = [
  {
    image: require('~/components/partials/landings/careers/images/values/1.webp'),
    // animation: 'fade-right',
    title: 'Purpose Before Action',
    subtitle: 'Remember which problem you’re solving',
    color: 'purple-3',
  },
  {
    image: require('~/components/partials/landings/careers/images/values/2.webp'),
    // animation: 'fade-up',
    title: 'Be Fearless',
    subtitle: 'Never be afraid to come up with a bold solution',
    color: 'cyan-3',
  },
  {
    image: require('~/components/partials/landings/careers/images/values/3.webp'),
    // animation: 'fade-up',
    title: 'Find Solutions, Not Problems',
    subtitle: 'Stay positive and proactive. Fixing things takes action',
    color: 'purple-1',
  },
  {
    image: require('~/components/partials/landings/careers/images/values/4.webp'),
    // animation: 'fade-left',
    title: 'Get Shit Done',
    subtitle: '‘Nuff said',
    color: 'cyan-0',
  },
  {
    image: require('~/components/partials/landings/careers/images/values/5.webp'),
    // animation: 'fade-left',
    title: 'Enjoy The Ride',
    subtitle: 'Have fun and be kind to yourself and to your peers',
    color: 'purple-4',
  },
  {
    image: require('~/components/partials/landings/careers/images/values/6.webp'),
    // animation: 'fade-left',
    title: 'Put On Your Sales Hat',
    subtitle: 'Represent the company and conduct yourself positively',
    color: 'brand',
  },
];

//
//
